import { Api } from '../../Api';
import { ListResult } from '../../interfaces';
import { ClientDetailsBody } from './body';
import { ISettingsAccountsDto } from '../Accounts';

export class ClientDetailsManagement {
    private static _basePath = '/User';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${ClientDetailsManagement._basePath}`;

        return {
            async get(query: any, parentAccountId: number) {
                const path = '/clients';

                return await Api.get<ListResult<ClientDetailsBody>>({
                    path: `${basePath}${path}`,
                    query: {
                        ...query,
                        parentAccountId: parentAccountId,
                    },
                });
            },
            async getUnassignedClient(query: any, parentAccountId: number) {
                const path = '/unassignedClients';

                return await Api.get<ListResult<ISettingsAccountsDto>>({
                    path: `${basePath}${path}`,
                    query: {
                        ...query,
                        parentAccountId: parentAccountId,
                    },
                });
            },

            async put(body: any) {
                const path = '/updatePermissions';
                return await Api.put<string>({
                    path: `${basePath}${path}`,
                    body,
                });
            },

            async deleteUser(id: number) {
                const path = '/unassignAccounts';
                return await Api.delete<string>({
                    path: `${basePath}${path}`,
                    query: {
                        Id: id,
                    },
                });
            },
        };
    }
}
